<big-ui-card [hasLink]="!!data.link">
    <div
        *transloco="let t; prefix: 'uiCard'"
        class="relative flex flex-col h-full min-w-0 overflow-hidden break-long-words group/item bg-clip-border"
        [ngClass]="{ 'md:flex-row': imagePlacement === 'right' || imagePlacement === 'left' }">
        <div
            class="flex-1 order-first h-full"
            [ngClass]="{
                'md:order-last': imagePlacement === 'right',
                'max-h-[160px] min-h-[160px] md:max-h-full md:min-h-[240px]': imagePlacement === 'right' || imagePlacement === 'left',
                'max-h-40 sm:h-[200px] sm:max-h-[200px] sm:min-h-[200px]': imagePlacement === 'top'
            }">
            <big-ui-picture
                [model]="data.image"
                class="object-cover w-full" />
        </div>
        <div
            class="flex-1"
            [ngClass]="{ 'order-last md:order-first!': imagePlacement === 'right' }">
            <div class="flex flex-col h-full px-4 py-8">
                @if (data.date) {
                    <p class="mb-4 text-[12px]">
                        <time>{{ data.date | date }}</time>
                    </p>
                }
                <h4 class="mb-4 group-hover/item:text-primary-light">{{ data.title }}</h4>
                @if (data.text) {
                    <div
                        class="tracking-wide grow"
                        [ngClass]="{
                            'mb-0': hideLink || !data.link,
                            'mb-4': !(hideLink || !data.link),
                        }"
                        [innerHTML]="data.text | nl2br | sanitize: securityContext"></div>
                }
                @if (data.link) {
                    <big-ui-link
                        class="text-primary group-hover/item:text-primary-light dark:text-dark-primary"
                        [href]="data.link.href"
                        [linkClass]="'tracking-wide font-bold no-underline after:absolute after:inset-0'">
                        <span
                            class="flex items-center"
                            [ngClass]="{ 'sr-only': hideLink }">
                            @if (data.link.title) {
                                {{ data.link.title }}
                            } @else {
                                {{ t('readMore') }}
                            }
                            <big-icon
                                class="mx-2 fill-current shrink-0"
                                [size]="'w-4'"
                                [inline]="true"
                                [icon]="iconArrowRight" />
                        </span>
                    </big-ui-link>
                }
            </div>
        </div>
    </div>
</big-ui-card>
